import index from "./zoom-config.vue";
export default index;
